import { Box, keyframes, styled } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';

const pulse = keyframes`
  0%   { transform: scale(1);   opacity: 0.4; }
  50%  { transform: scale(1.2); opacity: 1;   }
  100% { transform: scale(1);   opacity: 0.4; }
`;

const LoaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 8,
  minHeight: 200,
});

const PulsingIcon = styled(AutoAwesome)(({ theme }) => ({
  fontSize: 64,
  color: theme.palette.primary.main,
  animation: `${pulse} 2s infinite`,
}));

export const ThinkingLoader = () => (
  <LoaderBox>
    <PulsingIcon />
    <span>Searching…</span>
  </LoaderBox>
);
